import React from 'react';
import { FlagRound } from '../ui/FlagRound';
import { LogoMark } from '../ui/Logo';

interface Props {
  code?: string;
  name?: string;
  number?: string;
  tilt?: number;
  className?: string;
}

export function HeroSticker({
  code = 'BRA',
  name = 'Vinícius Júnior',
  number = '10',
  tilt = -3,
  className = '',
}: Props) {
  return (
    <div
      className={['relative w-full max-w-[360px] mx-auto', className].join(' ')}
      style={{ aspectRatio: '3 / 4', transform: `rotate(${tilt}deg)` }}
    >
      <div
        className="relative w-full h-full rounded-[18px] p-4 flex flex-col"
        style={{
          background:
            'linear-gradient(160deg, #FFFCEC 0%, #FFFFFF 50%, #F8F4D9 100%)',
          boxShadow:
            '0 14px 40px rgba(15, 26, 20, 0.18), 0 0 0 1px rgba(201, 162, 39, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
        }}
      >
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-[18px] pointer-events-none"
          style={{
            background:
              'linear-gradient(115deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 35%, rgba(255,255,255,0) 60%, rgba(241, 196, 15, 0.18) 100%)',
            mixBlendMode: 'screen',
          }}
        />

        <div className="relative flex items-center justify-between mb-2">
          <span className="font-mono font-bold text-ink-900 text-[14px] tracking-wider">
            {code} · {number}
          </span>
          <FlagRound code={code} size={28} />
        </div>

        <div className="relative flex-1 flex items-center justify-center">
          <span
            className="font-display font-extrabold text-green-700 leading-none tabular-nums"
            style={{
              fontSize: 'clamp(120px, 30vw, 168px)',
              textShadow: '4px 4px 0 rgba(241, 196, 15, 0.35)',
              letterSpacing: '-0.04em',
            }}
          >
            {number}
          </span>
        </div>

        <div className="relative flex items-center justify-between gap-3 pt-3 border-t border-ink-300/50">
          <div className="min-w-0">
            <p className="font-display font-bold text-[16px] text-ink-900 truncate">{name}</p>
            <p className="bt-eyebrow text-ink-500 mt-0.5">COPA 2026 · BRASIL</p>
          </div>
          <LogoMark size={24} />
        </div>
      </div>
    </div>
  );
}
